



import { useState } from "react";
import HeroSection from "./HeroSection";
import Highlights from "./Highlights";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Slide from "./Slide";
import JackpotSystems from "./JackpotSystems";
import KeyBenefits from "./KeyBenefits";
import ConclusionSection from "./ConclusionSection";
import ManagementSoftware from "./Management";
// import FeatureCards from "./FeatureCardNew";
export default function LandSlotsWebsite() {
  const [showContactModal, setShowContactModal] = useState(false);
  const [showDemoModal, setShowDemoModal] = useState(false);

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-b text-gray-200 ">
      {/* <Navbar/> */}
      
      {/* Hero Section */}
      <HeroSection
        onContactClick={() => setShowContactModal(true)}
        onDemoClick={() => setShowDemoModal(true)}
      />
<Slide/>
      {/* Main Content */}
      <main className="flex-grow w-full lg:px-8 px-4 lg:py-16 py-4 sm:py-8  bg-[#D9D9D9] mt-[2rem] sm:mt-0">
        <div className="max-w-[92rem] mx-auto">
          <Highlights />
          {/* <FeatureCards/> */}
        </div>
      </main>
      <JackpotSystems />
      <KeyBenefits />
      <ManagementSoftware />
      <ConclusionSection />
      {/* <Footer/> */}
    </div>
  );
}
